import {DECIMAL_FORMAT, numberFormat} from "../../../util/numbers.js";
import {getDirectionColorClassName} from "../../../util/misc.js";
import {useSelector} from "react-redux";
import {getAssetsTotalGain, getAssetsTotalValue} from "../../../ducks/assets-duck.js";
import {getDiffTrackerValues, getIsDiffTrackerVisible} from "../../../ducks/chart-duck.js";
import './DiffTracker.scss'
import {isToday} from "../../../util/time-and-date.js";
import PlusBoldIcon from "mdi-react/PlusBoldIcon.js";
import MinusThickIcon from "mdi-react/MinusThickIcon.js";
import dayjs from "dayjs";
import DirectionIcon from "../../util/icons/DirectionIcon.jsx";
import DateDiffHighlighter from "../../util/DateDiffHighlighter.jsx";
import {getDuration} from "./_overlay.js";

export default () => {

    const totalValue = useSelector(getAssetsTotalValue)
    const totalGain = useSelector(getAssetsTotalGain)

    const diffTrackerValues = useSelector(getDiffTrackerValues)
    const isVisible = useSelector(getIsDiffTrackerVisible)

    const {
        value,
        valuePrev,
        gain,
        gainPrev,
        date,
        relativePosition,
    } = diffTrackerValues

    const diffGain = totalGain - gain
    const diffValue = totalValue - value - diffGain

    const isCurrentDate = isToday(date)

    const diffValuePct = value === 0 ? 0 : Math.abs(diffValue / value * 100)
    const diffGainPct = value === 0 ? 0 : Math.abs(diffGain / value * 100)

    const gainChange = gain - gainPrev
    const gainChangePct = ((gain - gainPrev) / valuePrev) || 0

    const {
        duration,
        durationLabel,
        remainder,
        remainderLabel,
    } = getDuration(date)

    return (
        <div
            className={`diff-tracker hide-portrait ${isVisible && !isCurrentDate ? 'is-visible' : ''}`}
            style={{"--relativePosition": `${relativePosition * 5}rem`}}
            id='diff-tracker'
        >
            <div className='content'>
                <div className='flex-vertical-center date-range'>
                    <div className='hover-date'>
                        <DateDiffHighlighter date={date}/>
                        <div className='small dull'>
                            {dayjs(date).format('dddd')}
                        </div>
                    </div>
                    <div className='timespan'>
                        <label>{durationLabel}</label> <b>{duration}</b>
                        {remainder > 0 &&
                            <div className='small'>
                                <label>{remainderLabel}</label> <b>{remainder}</b>
                            </div>
                        }
                    </div>
                </div>
                <div className='change-header'>
                    <h4>
                        Change
                    </h4>
                </div>
                <div className='change'>
                    <DirectionIcon
                        value={gainChangePct}
                        isMultiColored={true}
                    />
                    <div className='value-then'>
                        {numberFormat(Math.abs(gainChange))}
                    </div>
                    <div className={`delta-pct ${getDirectionColorClassName(gainChangePct, true)}`}>
                        {numberFormat(Math.abs(gainChangePct * 100), DECIMAL_FORMAT.FLEX_PERCENTAGE)}<span
                        className='suffix'>%</span>
                    </div>
                </div>
                <div className='values'>
                    <div>
                        <h4>
                            Value
                        </h4>
                        <div>
                            <div className='value-then'>
                                {numberFormat(Math.abs(value))}
                            </div>
                            {Math.abs(diffValue) > .01 ?
                                <div className='current-delta'>
                                    {diffValue > 0 && <span className='transfer is-positive'>in</span>}
                                    {diffValue < 0 && <span className='transfer is-negative'>out</span>}
                                    <div className={`delta`}>
                                        {numberFormat(Math.abs(diffValue))}
                                    </div>
                                    <div className={`delta-pct ${getDirectionColorClassName(diffValue)}`}>
                                        {numberFormat(diffValuePct, DECIMAL_FORMAT.FLEX_PERCENTAGE)}<span
                                        className='suffix'>%</span>
                                    </div>
                                </div>
                                :
                                <div className='current-delta no-change'>
                                    —
                                </div>
                            }
                        </div>
                    </div>
                    <div className='right-side'>
                        <h4>
                            Return
                        </h4>
                        <div className=''>
                            <div className='value-then'>
                                {numberFormat(Math.abs(gain))}
                            </div>
                            {Math.abs(diffGain) > .01 ?
                                <div className='current-delta'>
                                    {diffGain > 0 && <PlusBoldIcon className='direction-icon is-positive'/>}
                                    {diffGain < 0 && <MinusThickIcon className='direction-icon is-negative'/>}
                                    <div className={`delta`}>
                                        {numberFormat(Math.abs(diffGain))}
                                    </div>
                                    <div className={`delta-pct ${getDirectionColorClassName(diffGain)}`}>
                                        {numberFormat(diffGainPct, DECIMAL_FORMAT.FLEX_PERCENTAGE)}<span
                                        className='suffix'>%</span>
                                    </div>
                                </div>
                                :
                                <div className='current-delta no-change'>
                                    —
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}